const moment = require('moment')

module.exports = {
  setAppInfo: (state, obj) => {
    state.appInfo = obj
  },
  setAppState: (state, obj) => {
    state.appState = obj
    if (obj === null) {
      localStorage.removeItem(`${process.env.APP_PREFIX}_appState`)
    } else {
      localStorage.setItem(`${process.env.APP_PREFIX}_appState`, JSON.stringify(obj))
    }
  },
  setChannel: (state, str) => {
    state.channel = str
    localStorage.setItem(`${process.env.APP_PREFIX}_channel`, str)
  },
  setUserChannel: (state, str) => {
    state.userChannel = str
    localStorage.setItem(`${process.env.APP_PREFIX}_userChannel`, str)
  },
  setDeviceId: (state, str) => {
    state.deviceId = str
  },
  setRouteState: (state, obj) => {
    state.routeState = obj
  },
  setLoading: (state, bool) => {
    state.loading = bool
  },
  setErrors: (state, arr) => {
    state.errors = arr
  },
  setLocation: (state, obj) => {
    if (obj === null) {
      localStorage.removeItem(`${process.env.APP_PREFIX}_location`)
    } else {
      localStorage.setItem(`${process.env.APP_PREFIX}_location`, JSON.stringify(obj))
    }
    state.location = obj
  },
  setMenu: (state, obj) => {
    // if (obj === null) {
    //   localStorage.removeItem(`${process.env.APP_PREFIX}_menu`);
    // } else {
    //   localStorage.setItem(
    //     `${process.env.APP_PREFIX}_menu`,
    //     JSON.stringify(obj)
    //   );
    // }

    // TODO: do not remove this until we are sure we removed the menu from local storage from all clients
    localStorage.removeItem(`${process.env.APP_PREFIX}_menu`)

    state.menu = obj
  },
  setToken: (state, obj) => {
    if (obj === null) {
      localStorage.removeItem(`${process.env.APP_PREFIX}_token`)
    } else {
      localStorage.setItem(`${process.env.APP_PREFIX}_token`, JSON.stringify(obj))
    }
    state.token = obj
  },
  setUser: (state, obj) => {
    if (obj === null) {
      localStorage.removeItem(`${process.env.APP_PREFIX}_user`)
    } else {
      localStorage.setItem(`${process.env.APP_PREFIX}_user`, JSON.stringify(obj))
    }
    state.user = obj
  },
  setCart: (state, obj) => {
    if (obj === null) {
      localStorage.removeItem(`${process.env.APP_PREFIX}_cart`)
    } else {
      if (!localStorage.getItem(`site_load`)) {
        obj.reset = moment().add(30, 'minutes').format('LLLL')
      }
      localStorage.setItem(`${process.env.APP_PREFIX}_cart`, JSON.stringify(obj))
    }
    state.cart = obj
  },
  setRewards: (state, arr) => {
    state.rewards = arr
  },
  setShowCart: (state, bool) => {
    state.showCart = bool
  },
  setIsUpsellsView(state, status) {
    state.isUpsellsView = status
  },
  setIsUpsellsModalView(state, status) {
    state.isUpsellsModalView = status
  },
  setShowNav: (state, bool) => {
    state.showNav = bool
  },
  setActiveAccountSection: (state, string) => {
    state.activeAccountSection = string
  },
  setOrderHistory: (state, arr) => {
    state.orderHistory = arr
  },
  setFilteredMenu: (state, arr) => {
    state.filteredMenu = arr
  },
  setSearchedMenu: (state, bool) => {
    state.searchedMenu = bool
  },
  setCategory: (state, obj) => {
    state.category = obj
  },
  setCategoryBrands: (state, obj) => {
    state.categoryBrands = obj
  },
  setActiveSuperCategory: (state, string) => {
    state.ActiveSuperCategory = string
  },
  setDietaryFilters: (state, arr) => {
    state.dietaryFilters = arr
  },
  setHowToRedeem: (state, obj) => {
    state.howToRedeem = obj
  },
  setGeolocation: (state, obj) => {
    state.geolocation = obj
  },
  setShowSitePopup: (state, bool) => {
    state.showSitePopup = bool
  },
  setSitePopupInfo: (state, obj) => {
    state.sitePopupInfo = obj
  },
  setGlobals: (state, obj) => {
    state.globals = obj
  },
  setShowWelcomePopup: (state, bool) => {
    state.showWelcomePopup = bool
  },
  setShowGroupOrderModal: (state, bool) => {
    state.showGroupOrderModal = bool
  },
  setShowGroupOrderModalJoin: (state, bool) => {
    state.showGroupOrderModalJoin = bool
  },
  setGroupOrderOptions: (state, obj) => {
    state.groupOrderOptions = obj
  },
  setStartingGroupOrder: (state, obj) => {
    state.startingGroupOrder = obj
  },
  setGroupOrder: (state, obj) => {
    if (obj === null) {
      localStorage.removeItem(`${process.env.APP_PREFIX}_group_order`)
    } else {
      localStorage.setItem(`${process.env.APP_PREFIX}_group_order`, JSON.stringify(obj))
    }
    state.groupOrder = obj
  },
  setFailed: (state, obj) => {
    state.failed = obj
  },
}
